module.exports = __webpack_public_path__ + "static/media/style1-2.95ec7c98.gif";